import React from 'react';

import '../Tutorial.css';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T60SelectAttack() {

  /*
  useEffect(() => {
    UserService.sendEvent('SelectAttack60');
  }, []); */

    const text = 'Attack the enemy with the \'Minion\' card! To attack, tap or click on the card.';

    return (
        <div>

            <div className='SelectAttack60Top'>
            </div>
       
            <div className='SelectAttack60Right'></div>

            <TutorialGirl position={'Right'}/>
            <div className='tutorialContainer tutorialTopContainerShoRes35'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>

        </div>

    );
}

export default T60SelectAttack;
